export default {
    init() {
      // JavaScript to be fired on the online dementia course page
  
    },
    finalize() {
      const lastcount = $("body").find('.subcoursediv').last().attr('totalcount');
      lastcount == 1 ? $(".manuallyupdate").addClass('pos-fixed') : $(".manuallyupdate").removeClass('pos-fixed');
    
     $('.facetwp-checkbox').on('click', function() {
      setTimeout(function() { 
          var lastcount = $("body").find('.subcoursediv').last().attr('totalcount');
          lastcount == 1 ? $(".manuallyupdate").addClass('pos-fixed') : $(".manuallyupdate").removeClass('pos-fixed');
      }, 2000);
    });
  }
}


// WEBPACK FOOTER //
// ./scripts/routes/online-dementia-courses.js